export const MAX_TICKETS_IN_BASKET = 7;
